const isKeycloakTokenExpiredSafe = (keycloak) => {
  try {
    return keycloak?.isTokenExpired()
  } catch (keycloakIsTokenExpiredError) {
    // source code seems to throw when no refresh token present:
    // https://github.com/keycloak/keycloak/blob/main/js/libs/keycloak-js/src/keycloak.js#L611
    console.debug(
      '[keycloakUtils.isKeycloakTokenExpiredSafe][error] failed to check token validity, returning true.',
    )
    return true
  }
}

export { isKeycloakTokenExpiredSafe }
